import type { Rarity } from "../game/types";
import { ITEMS } from "../content/items";
import { CharacterPortrait } from "../render/characterSprites";
import { EnemyIcon } from "../render/enemySprites";
import { ItemSprite } from "../render/itemSprites";
import { NpcPortrait } from "../render/npcSprites";
import { AnimalPortrait, PetPortrait } from "../render/petSprites";
import { BuildingThumbnail, SettlementBanner } from "../render/worldSprites";

export { CharacterPortrait, EnemyIcon, NpcPortrait, PetPortrait, AnimalPortrait, BuildingThumbnail, SettlementBanner };

export function ItemIcon({ itemId, size = 40, rarity }: { itemId: string; size?: number; rarity?: Rarity }) {
  return <span className={`item-icon authored-item-icon rarity-${rarity ?? ITEMS[itemId]?.rarity ?? "common"}`} style={{ width: size, height: size, "--item-color": ITEMS[itemId]?.color ?? "#9a8b68" } as React.CSSProperties}><ItemSprite itemId={itemId} size={size} rarity={rarity} /></span>;
}
